export default __webpack_public_path__ + "static/media/AtomicModelImg.cb90a6f0.jpg";